import { createFileRoute } from '@tanstack/react-router';

import { useAnalyticsHealth } from '~/features/analytics/hooks.js';

export const Route = createFileRoute('/_auth/analytics/config')({
  component: AnalyticsConfig,
});

const PLAUSIBLE_URL = (import.meta.env.VITE_PLAUSIBLE_URL as string | undefined) || '';

function AnalyticsConfig() {
  const { data, isLoading } = useAnalyticsHealth();

  return (
    <div className="analytics-page">
      <section className="analytics-block">
        <header className="analytics-block__head">
          <h2 className="analytics-block__title">Status do Plausible</h2>
        </header>
        {isLoading || !data ? (
          <p className="analytics-empty">Carregando...</p>
        ) : (
          <dl className="analytics-status">
            <div>
              <dt>Conexão</dt>
              <dd>
                {data.plausibleConnected ? (
                  <span className="analytics-pill analytics-pill--ok">conectado</span>
                ) : (
                  <span className="analytics-pill analytics-pill--mock">modo mock (dev)</span>
                )}
              </dd>
            </div>
            <div>
              <dt>Última consulta</dt>
              <dd>
                {data.lastQueryAt ? new Date(data.lastQueryAt).toLocaleString('pt-BR') : 'nunca'}
              </dd>
            </div>
            {PLAUSIBLE_URL && (
              <div>
                <dt>Dashboard nativo</dt>
                <dd>
                  <a href={PLAUSIBLE_URL} target="_blank" rel="noopener noreferrer">
                    Abrir Plausible →
                  </a>
                </dd>
              </div>
            )}
          </dl>
        )}
      </section>

      <section className="analytics-block">
        <header className="analytics-block__head">
          <h2 className="analytics-block__title">Eventos custom configurados</h2>
        </header>
        <ul className="analytics-events-list">
          <li>
            <code>contact_form_submit</code>
            <span>Submit do formulário principal (`/contato`).</span>
          </li>
          <li>
            <code>newsletter_signup</code>
            <span>Inscrição na newsletter (rodapé + página dedicada).</span>
          </li>
          <li>
            <code>pdf_download</code>
            <span>
              Clique em qualquer link <code>.pdf</code> (delegation global).
            </span>
          </li>
          <li>
            <code>article_read</code>
            <span>Leitura ≥ 75% do corpo do artigo (IntersectionObserver).</span>
          </li>
        </ul>
        <p className="analytics-block__note">
          Para adicionar novos eventos, cabear <code>trackEvent(name, props)</code> no site público
          (vide <code>apps/web/src/lib/analytics.ts</code>).
        </p>
      </section>
    </div>
  );
}
